// extracted by mini-css-extract-plugin
export default {"melodyVideo":"eJ-z","isFullWidth":"fJ-z","landingPageVideo":"gJ-z","play":"hJ-z","iframeVideo":"iJ-z","playHidden":"jJ-z","fullwidth":"kJ-z"};